import React from "react";
import { Link } from "react-router-dom";
import { useAuth, hasPermission } from "../../context/AuthContext";
import { useBoilerWorkspace } from "../../hooks/useBoilerWorkspace";
import { SectionCard, Pill } from "../Ui";
import RuntimeCounter from "../RuntimeCounter";
import { ArrowRight, Flame } from "lucide-react";

/** Compact combipack boiler status for manager dashboards. */
export default function BoilerRuntimeSummary() {
  const { user } = useAuth();
  const canView = hasPermission(user, "page.production_boiler");
  const { runtime, bedTracking, loading, data } = useBoilerWorkspace();

  if (!canView) return null;

  const isRunning = runtime?.status === "RUNNING";

  return (
    <SectionCard
      title="Combipack Boiler"
      testId="boiler-runtime-summary"
      action={(
        <Link to="/production/boiler" className="text-xs uppercase tracking-widest link-brand inline-flex items-center gap-1">
          Open workspace <ArrowRight className="h-3 w-3" />
        </Link>
      )}
    >
      {loading && !data ? (
        <p className="text-sm text-muted-foreground py-4 text-center">Loading…</p>
      ) : (
        <div className="rounded-xl border px-4 py-3 border-bansal-sage/40 bg-bansal-sage/5">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 min-w-0">
              <Flame className="h-4 w-4 text-primary shrink-0" />
              <span className="font-medium text-sm truncate">{data?.boiler_name || "Thermax 10-Ton Combipack"}</span>
            </div>
            <Pill tone={isRunning ? "sage" : "default"}>{runtime?.status || "STOPPED"}</Pill>
          </div>
          <div className="mt-2">
            <RuntimeCounter
              startTime={runtime?.start_time}
              running={isRunning}
              showVerbose={false}
              clockClassName="font-mono text-xl tabular-nums text-primary"
            />
          </div>
          {isRunning && (
            <p className="text-xs text-muted-foreground mt-2">
              Bed 1: {Number(bedTracking?.bed1_active_hours || 0).toFixed(1)}h
              {" · "}
              Bed 2: {Number(bedTracking?.bed2_active_hours || 0).toFixed(1)}h
            </p>
          )}
          {runtime?.started_by_name && (
            <div className="text-xs text-muted-foreground mt-1 truncate">By {runtime.started_by_name}</div>
          )}
        </div>
      )}
    </SectionCard>
  );
}
